import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  IconButton,
  MobileStepper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

const SlideImagePreview = ({ open, onClose, slide }) => {
  const [activeStep, setActiveStep] = useState(0);
  if (!slide) return null;

  const structure = slide.foreground_structure;
  const showText = ["texts", "text_image", "image_text"].includes(structure);
  const showImage = [
    "images",
    "text_image",
    "image_text",
    "multi_media",
  ].includes(structure);

  const isVideo = (url = "") =>
    url.endsWith(".mp4") || url.endsWith(".webm") || url.endsWith(".ogg");
  const maxSteps = slide.multi_media?.length || 0;

  const handleNext = () => {
    setActiveStep((prev) => Math.min(prev + 1, maxSteps - 1));
  };

  const handleBack = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0));
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          top: 10,
          right: 10,
          background: "#E2E2EA",
          borderRadius: "50%",
          width: 26,
          height: 26,
        }}
      >
        <CloseIcon />
      </IconButton>
      <Typography
        fontWeight={700}
        fontSize={24}
        p={2}
        sx={{
          background: "linear-gradient(90deg, #7028DA 0%, #9E3ED7 76.93%)",
          color: "#fff",
        }}
      >
        {" "}
        Slide Preview
      </Typography>

      <DialogContent>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          {/* MOBILE FRAME */}
          <Box
            sx={{
              width: 360,
              height: 600,
              border: "10px solid #000",
              borderRadius: "28px",
              background: "#fff",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              position: "relative",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: 8,
                left: "50%",
                transform: "translateX(-50%)",
                width: 12,
                height: 12,
                borderRadius: "50%",
                background: "#000",
                zIndex: 2,
              }}
            />

            {/* CONTENT */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                px: 2,
              }}
            >
              {showText && (
                <Box sx={{ mb: 2, textAlign: "center" }}>
                  <Typography variant="subtitle2" color="primary">
                    Text
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ textAlign: "center" }}
                    fontWeight={700}
                    fontSize={24}
                  >
                    {slide.foreground_texts?.[0]?.text || "No text provided"}
                  </Typography>
                </Box>
              )}

              {structure === "multi_media" ? (
                <>
                  {slide.multi_media?.[activeStep]?.mediaType === "image" ? (
                    <img
                      src={slide.multi_media[activeStep].fullPath}
                      alt="Slide Media"
                      style={{
                        width: "100%",
                        height: "60%",
                        objectFit: "contain",
                        borderRadius: 8,
                      }}
                    />
                  ) : (
                    <video
                      src={slide.multi_media?.[activeStep]?.fullPath}
                      controls
                      style={{
                        width: "100%",
                        height: "60%",
                        objectFit: "contain",
                        borderRadius: 8,
                      }}
                    />
                  )}

                  {/* STEPPER */}
                  {maxSteps > 1 && (
                    <MobileStepper
                      steps={maxSteps}
                      position="static"
                      activeStep={activeStep}
                      nextButton={
                        <IconButton
                          onClick={handleNext}
                          disabled={activeStep === maxSteps - 1}
                        >
                        <KeyboardArrowRight /> 
                        </IconButton>
                      }
                      backButton={
                        <IconButton
                          onClick={handleBack}
                          disabled={activeStep === 0}
                        >
                          <KeyboardArrowLeft /> 
                        </IconButton>
                      }
                    />
                  )}
                </>
              ) : isVideo(slide.background_image) ? (
                <video
                  src={slide.background_image}
                  controls
                  autoPlay
                  muted
                  playsInline
                  style={{ width: "100%", height: "60%", borderRadius: 8 }}
                />
              ) : (
                <img
                  src={slide.background_image}
                  alt="Slide Visual"
                  style={{
                    width: "100%",
                    height: "60%",
                    objectFit: "contain",
                    borderRadius: 8,
                  }}
                />
              )}
            </Box>
            <Box
              sx={{
                height: 50,
                borderTop: "1px solid #ddd",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-around",
              }}
            >
              <IconButton onClick={handleBack} disabled={activeStep === 0}>
                <KeyboardArrowLeft />
              </IconButton>

              <IconButton>
                <RadioButtonUncheckedIcon />
              </IconButton>

              <IconButton
                onClick={handleNext}
                disabled={activeStep === maxSteps - 1}
              >
                <KeyboardArrowRight />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SlideImagePreview;
